export default __webpack_public_path__ + "static/media/survey-checkin.bdf54bb0.svg";